import { render, staticRenderFns } from "./GamesInfoRoute.vue?vue&type=template&id=77f82bf8&scoped=true&"
import script from "./GamesInfoRoute.vue?vue&type=script&lang=js&"
export * from "./GamesInfoRoute.vue?vue&type=script&lang=js&"
import style0 from "./GamesInfoRoute.vue?vue&type=style&index=0&id=77f82bf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f82bf8",
  null
  
)

export default component.exports